// @catalog F.006
// @catalog F.030
// SubnavTabs — pestañas underline para subnavegación dentro de /ventas y /margenes.
// Reemplaza CollapsibleTableSection como mecanismo de navegación entre vistas.
import { Box } from "@mui/material";

export interface SubnavTab<TKey extends string = string> {
  key: TKey;
  label: string;
  badge?: number | string | undefined;
}

interface SubnavTabsProps<TKey extends string = string> {
  tabs: ReadonlyArray<SubnavTab<TKey>>;
  active: TKey;
  onChange: (next: TKey) => void;
}

export function SubnavTabs<TKey extends string = string>(
  props: SubnavTabsProps<TKey>,
): JSX.Element {
  const { tabs, active, onChange } = props;

  return (
    <Box
      role="tablist"
      sx={{
        display: "inline-flex",
        borderBottom: "1px solid var(--border)",
        marginBottom: "16px",
        gap: "4px",
      }}
    >
      {tabs.map((t) => {
        const isActive = t.key === active;
        return (
          <Box
            key={t.key}
            component="button"
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(t.key)}
            sx={{
              padding: "8px 14px 10px",
              fontSize: "13px",
              color: isActive ? "var(--ink-1)" : "var(--ink-3)",
              fontWeight: 500,
              borderBottom: "2px solid",
              borderBottomColor: isActive ? "var(--accent)" : "transparent",
              marginBottom: "-1px",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              fontFamily: "inherit",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              "&:hover": { color: "var(--ink-1)" },
              "&:focus-visible": {
                outline: "2px solid var(--accent)",
                outlineOffset: "2px",
                borderRadius: "2px",
              },
            }}
          >
            <Box component="span" sx={{ borderBottom: "2px solid transparent" }}>
              {t.label}
            </Box>
            {t.badge !== undefined && t.badge !== null && t.badge !== "" && (
              <Box
                component="span"
                sx={{
                  fontSize: "11px",
                  padding: "0 6px",
                  borderRadius: "10px",
                  backgroundColor: "var(--bg-2)",
                  color: "var(--ink-2)",
                  fontWeight: 600,
                  lineHeight: "18px",
                }}
              >
                {t.badge}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
